import { Module } from 'vuex'

import { DashboardUseCase } from '@/application/dashboard/dashboardUseCase'
import { WeeklyRating } from '@/domain/entities/dashboard/weeklyRating'
import { DashboardRepository } from '@/domain/repositories/dashboard/DashboardRepository'

interface WeeklyRatingState {
  userWeeklyRatingList: WeeklyRating[][]
  chartData: { labelChartData: number[]; weeklyRatingChartData: number[][]; maxRating: number }
  chartSeries: any[]
  chartOptions: any
  hasData: boolean
  isLoading: boolean
  error: Error | null
}

export const weeklyRatingModule = (repository: DashboardRepository): Module<WeeklyRatingState, any> => {
  const usecase = new DashboardUseCase(repository)

  return {
    namespaced: true,
    state: {
      userWeeklyRatingList: [],
      chartData: { labelChartData: [], weeklyRatingChartData: [], maxRating: 0 },
      chartSeries: [],
      chartOptions: {},
      hasData: false,
      isLoading: false,
      error: null
    },
    mutations: {
      setUserWeeklyRatingList(state, { weekly }: { weekly: WeeklyRating[][] }) {
        state.userWeeklyRatingList = weekly
      },
      addUserWeeklyRating(state, { weekly }: { weekly: WeeklyRating[] }) {
        state.userWeeklyRatingList.push(weekly)
      },
      removeUserWeeklyRating(state) {
        state.userWeeklyRatingList.splice(0)
      },
      removeTargetUsers(state) {
        state.userWeeklyRatingList.splice(1)
      },
      setChartData(
        state,
        chartData: { labelChartData: number[]; weeklyRatingChartData: number[][]; maxRating: number }
      ) {
        state.chartData = chartData
      },
      setChartSeries(state, chartSeries: any[]) {
        state.chartSeries = chartSeries
      },
      setChartOptions(state, chartOptions: any) {
        state.chartOptions = chartOptions
      },
      setHasData(state, hasData: boolean) {
        state.hasData = hasData
      },
      setIsLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: Error | null) {
        state.error = error
      }
    },

    actions: {
      async addUserWeeklyRating({ state, commit }, { userId }: { userId: string }) {
        commit('setIsLoading', true)
        commit('setError', null)

        try {
          const res = await usecase.getWeeklyRatingList(userId)
          commit('addUserWeeklyRating', {
            weekly: res
          })
        } catch (e) {
          commit('setError', e)
        } finally {
          commit('setIsLoading', false)
        }
      }
    },
    getters: {
      userWeeklyRatingList: state => state.userWeeklyRatingList,
      chartData: state => state.chartData,
      chartSeries: state => state.chartSeries,
      chartOptions: state => state.chartOptions,
      hasData: state => state.hasData,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
